import { TLLM } from '../../../../universal';
const INTELLIGENCE_LOCAL_STORAGE_KEY = 'agentIntelligenceTier';
export const getStoredIntelligenceTier = () => TLLM.INTELLIGENCE_TIERS.find(tier => tier.key ===
    (typeof localStorage === 'undefined'
        ? null
        : localStorage.getItem(INTELLIGENCE_LOCAL_STORAGE_KEY)))?.key ?? TLLM.DEFAULT_INTELLIGENCE_TIER;
export const storeIntelligenceTier = (intelligence) => {
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem(INTELLIGENCE_LOCAL_STORAGE_KEY, intelligence);
    }
};
export const createEmptyInputState = (intelligence = getStoredIntelligenceTier()) => ({
    text: '',
    voice: { status: 'idle' },
    attachments: [],
    intelligence,
});
export const MAX_ATTACHMENTS = 10;
export const ALLOWED_ATTACHMENT_TYPES = {
    image: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'],
    pdf: ['application/pdf'],
    xlsx: [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
    ],
};
export const getAttachmentType = (mimeType) => {
    if (mimeType.startsWith('image/')) {
        return 'image';
    }
    if (ALLOWED_ATTACHMENT_TYPES.pdf.includes(mimeType)) {
        return 'pdf';
    }
    if (ALLOWED_ATTACHMENT_TYPES.xlsx.includes(mimeType)) {
        return 'xlsx';
    }
    return null;
};
export const getAttachmentUrl = (guid) => `https://storage.trionline.com.au/get-v3/${guid}`;
//# sourceMappingURL=types.js.map